import { IArtifactComponentProps } from "types/services";
import { IInteriorPropertyDetailsArtifact } from "types/artifacts/interior-property-details";
import { IPropertyId } from "types/artifacts/common";
import { ExteriorOrInteriorOrRoomCard } from "components/ExteriorOrInteriorOrRoomCard";
import { findArtifactByHarid, haridMatches } from "utils/helpers";
import { isProduction } from "scripts/application/setting";

export type IInteriorPropertyDetailsOutputProps = IArtifactComponentProps<
    IPropertyId,
    IInteriorPropertyDetailsArtifact
>;

InteriorPropertyDetailsOutput.artifactKey = "property_detail";

export function InteriorPropertyDetailsOutput(props: IInteriorPropertyDetailsOutputProps): JSX.Element {
    const { harid, artifacts = [] } = props;

    // if there is no valid artifacts return from the backend
    if (!Array.isArray(artifacts)) return <></>;

    if (harid) {
        const artifactsCount = artifacts.length;
        const artifact = artifactsCount > 1 ? artifacts.find((x) => haridMatches(x.harid, harid) && (x?.select_fields && Array.isArray(x?.select_fields) ? x.select_fields : [])[0] === "interior") : findArtifactByHarid(artifacts, harid);
        const interior = artifact?.response?.interior;
        const { artifact_text, ...remainingInteriorProperties } = interior || {};
        if (artifact && interior) {
            return (
                <div className="mb-md-4 mb-3 without-ad" style={{ width: '98%' }}>
                    <h2>Interior</h2>
                    <ExteriorOrInteriorOrRoomCard data={remainingInteriorProperties} />
                </div>
            );
        }

        console.error(
            "No artifact or interior found for 'InteriorPropertyDetailsOutput' with the given harid:",
            harid
        );

        return <></>;
    }

    console.error(
        "No harid provided for 'InteriorPropertyDetailsOutput'."
    );

    return <></>;
}

InteriorPropertyDetailsOutput.asText = function (props: IInteriorPropertyDetailsOutputProps): string {
    // console.log("InteriorPropertyDetailsOutput.asText", props);
    return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.interior?.artifact_text || "" : isProduction ? "" : "InteriorPropertyDetailsOutput asText Not Implemented!";
}

